import { useState } from "react";

//interfaces
import { IToolTipIcon } from "@/interfaces/tooltipIcon";

//styling
import '../../../css/toolTipIcon.scss';



const ToolTipIcon = ({ icon, tooltipText }: IToolTipIcon) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
        <div className="tooltip-icon-container" onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)} data-testid="tooltip-test">
            <div className="icon">{icon}</div>
            
            {isVisible && <div className="tooltip">{tooltipText}</div>}
        </div>
  );
};

export default ToolTipIcon;